import axios from "axios";
import { api } from "@/lib/api";
import { registerOfflineClient } from "@/lib/offlineQueue";

// Raw instance for standalone desktop logins (token in localStorage).
export const desk = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 60_000,
});
desk.interceptors.request.use((c) => {
  const t = localStorage.getItem("desktop_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
desk.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && window.location.pathname.startsWith("/desktop")
        && localStorage.getItem("desktop_token")) {
      localStorage.removeItem("desktop_token");
      window.location.reload(); // back to the /desktop login view
    }
    return Promise.reject(e);
  }
);

// "admin" while a management admin uses the shared desktop at /desktop, even if a desktop login is saved.
let deskMode = null;
export const setDeskMode = (m) => { deskMode = m; };

const isDeskSession = () =>
  deskMode !== "admin" && window.location.pathname.startsWith("/desktop") && !!localStorage.getItem("desktop_token");

// Drop-in `api` replacement for the desktop apps: routes calls through the
// desktop-login session on /desktop, or the normal admin session elsewhere.
export const dapi = {
  get: (...a) => (isDeskSession() ? desk : api).get(...a),
  post: (...a) => (isDeskSession() ? desk : api).post(...a),
  put: (...a) => (isDeskSession() ? desk : api).put(...a),
  patch: (...a) => (isDeskSession() ? desk : api).patch(...a),
  delete: (...a) => (isDeskSession() ? desk : api).delete(...a),
  request: (cfg) => (isDeskSession() ? desk : api).request(cfg),
};

// Desktop offline queue: Word/Excel/text saves made without internet replay
// automatically once the connection returns.
registerOfflineClient("desk", dapi);
